import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    certificateCategories: [],
    certificateCategoriesLoaded: false,
  }),
  mutations: {
    SET_CERTIFICATECATEGORIES(state, categories) {
      state.certificateCategories = categories
      state.certificateCategoriesLoaded = true
    },
  },
  actions: {
    async fetchCertificateCategories({ commit, state }) {
      if (!state.certificateCategoriesLoaded) {
        const res = await axios.get('certificate-categories')
        const { data } = decryptData(res.data.payload).data
        const formatted = data.map(item => ({
          value: item.id,
          label: item.name,
        }))
        commit('SET_CERTIFICATECATEGORIES', [...formatted])
      }
    },
  },
  getters: {
    certificateCategories: state => state.certificateCategories,
    certificateCategoriesLoaded: state => state.certificateCategoriesLoaded,
  },
}
